import React from 'react'
import {isRedirect} from '@reach/router'
import Error from './error'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = {error: props.error}
  }

  static getDerivedStateFromError(error) {
    if (isRedirect(error)) {
      throw error
    }
    // Update state so the next render will show the fallback UI.
    return {error}
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
  }

  render() {
    if (this.state.error && !this.state.isSilent) {
      return (<Error error={this.state.error} onClose={() => this.setState({error: null})}/>)
    }
    return this.props.children || null
  }
}

export {ErrorBoundary}

export default ErrorBoundary